import React from 'react';

const ZoomIcon = ({ className = "h-5 w-5", ...props }) => {
  return (
    <svg 
      viewBox="0 0 48 48" 
      className={className}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#2D8CFF"/>
      <path 
        d="M16 14h12c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H16c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2z" 
        fill="white"
      />
      <path 
        d="M30 17.5v9l6-3v-3l-6-3z" 
        fill="white"
      />
    </svg>
  );
};

export default ZoomIcon;
